/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IVitals } from 'app/shared/model/vitals.model';
import { INurse } from 'app/shared/model/nurse.model';
import { ITreatmentCycle } from 'app/shared/model/treatment-cycle.model';
import { ITreatmentRadiation } from 'app/shared/model/treatment-radiation.model';

export interface ITreatmentSessionVitals {
  id?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  notes?: string | null;
  vitals?: IVitals | null;
  recordingNurse?: INurse | null;
  validatingNurse?: INurse | null;
  cycle?: ITreatmentCycle | null;
  radiationSession?: ITreatmentRadiation | null;
}

export const defaultValue: Readonly<ITreatmentSessionVitals> = {
  active: false,
};
